/* eslint-disable no-unused-vars */

/**
 * @typedef Resolver<T>
 * @type {(data: T) => void}
 * @see Promise
 */

/**
 * @typedef Rejector
 * @type {(error: Error | any) => void}
 * @see Promise
 */

/**
 * 全局队列列表
 * @type {Record<string, Array<[Resolver, Rejector]>>}
 */
const GLOBAL_QUEUES = {};

/**
 * 以 {@link id} 为唯一键的异步处理队列: 相同 {@link id}下, 同一时间有且仅有一个 {@link func} 会被执行,
 * 这个 {@link func} 执行后返回的数据, 将会发送给所有在队列中相同 {@link id} 的 {@link func}
 * @param {string} id 唯一键
 * @param {() => Promise} func 异步方法
 * @return {Promise}
 */
export function queued(id, func) {
  if (GLOBAL_QUEUES[id]) {
    return new Promise((resolve, reject) => {
      GLOBAL_QUEUES[id].push([resolve, reject]);
    });
  }
  GLOBAL_QUEUES[id] = [];
  return new Promise((resolve, reject) => {
    func().then((res) => {
      resolve(res);
      GLOBAL_QUEUES[id].forEach(([resolve]) => resolve(res));
    }).catch((e) => {
      reject(e);
      GLOBAL_QUEUES[id].forEach(([_, reject]) => reject(e));
    }).finally(() => {
      delete GLOBAL_QUEUES[id];
    });
  });
}
